import * as types from '../constants/vasActionTypes';
import { appSettings } from '../../app/appSettings'
import pako from 'pako';

const initialState = {
    isGetCustomsCityAPILoading: false,
    GetCustomsCityAPISuccessful: false,

    isCustomsCityMessagesLoading: false,
    CustomsCityMessagesData: [],

    isDashboardSummaryLoading: false,
    DashboardSummaryData: [],

    isMawbLoading: false,
    MawbData: [],

    MawbSaveSuccessful: false,
    MawbEvolveDataSaveSuccessful: false,
    MawbAddSuccessful: false,

    isMawbRecoveryLoading: false,
    MawbRecoveryData: [],

    MawbRecoverySaveSuccessful: false,

    MawbPickupSaveSuccessful: false,

    isMawbStatusLoading: false,
    MawbStatusData: [],

    MawbStatusPostSuccessful: false,

    isMawbCarrierLoading: false,
    MawbCarrierData: [],

    isHawbLoading: false,
    HawbData: [],

    isHawbT86Loading: false,
    HawbT86Data: [],

    PostHawbSuccessful: false,

    isHawbRecoveryLoading: false,
    HawbRecoveryData: [],

    HawbRecoverySaveSuccessful: false,

    isHawbConsigneeLoading: false,
    HawbConsigneeData: [],

    isHawbDestinationLoading: false,
    HawbDestinationData: [],

    isLoadLoading: false,
    LoadData: [],

    isLoadHawbLoading: false,
    LoadHawbData: [],

    PostLoadSuccessful: false,

    PostLoadRemoveSuccessful: false,

    PostLoadEditSuccessful: false,

    isLoadHawbHistoryLoading: false,
    LoadHawbHistoryData: [],


    isOutboundLoading: false,
    OutboundData: [],


    PostUserColorSuccessful: false,

    HawbRecoveredShortPostSuccessful: false,

    isXdockMawbFileUploadLoading: false,
    XdockMawbFileUploadData: [],

    XdockMawbFileUploadPostSuccessful: false,


    isXdockLoadFileUploadLoading: false,
    XdockLoadFileUploadData: [],
    XdockLoadFileUploadPostSuccessful: false,


    isXdockTrinityDataFileLoading: false,
    XdockTrinityDataFileData: [],

    isXdockTrinityDataLoading: false,
    XdockTrinityData: [],

    isXdockLoadPalletCartonLoading: false,
    XdockLoadPalletCartonData: [],

    XDockLoadPalletCartonPostSuccessful: false,
    newPalletIDCarton: null,

    XDockLoadPalletPostSuccessful: false,
    newPalletID: null,

    isXdockLoadPalletLoading: false,
    XdockLoadPalletData: [],

    isXdockCustomsCityManifestHistoryLoading: false,
    XdockCustomsCityManifestHistoryData: [],

    isXdockHawbT86ListGetLoading: false,
    XdockHawbT86ListData: [],


    XDockMawbCarrierRefPostSuccessful: false,
    newCarrierID: null



};

function checkStatusCode(payload) {
    var errorType = 'None'
    try {
        errorType = payload['errorType']
    }
    catch (e) {
    }
    if (typeof (errorType) !== 'undefined') {
        return false
    }
    else {
        var res = payload['statusCode']
        try {
            if (res === "200" || res == 200 || res == 600 || res === "600") { return true }
            else { return false }
        }
        catch (e) {
            return false
        }
    }
}

function actionOnError(proc) {
    console.log('DB connection error')
    // sessionStorage.clear();
    // window.location.reload();
    // window.alert('Session expired, please log in again.')

    return initialState


}



//Compressed Data Helper Functions
function decodeAndDecompress(data) {
    try {
        var binaryString = atob(data);
        var len = binaryString.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        var decompressedData = pako.inflate(bytes, { to: 'string' });
        return JSON.parse(decompressedData);
    } catch (error) {
        console.error('Error decoding base64 data:', error);
        return [];
    }
}
function handleAction(state, action, loadingKey, dataKey, getActionType, completeActionType) {
    switch (action.type) {
        case getActionType:
            return { ...state, [loadingKey]: true };
        case completeActionType:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            try {
                var compressedBody = JSON.parse(action.payload.body);
                var newData = decodeAndDecompress(compressedBody.compressed_data);
                return { ...state, [loadingKey]: false, [dataKey]: newData };
            } catch (error) {
                console.error('Error decoding base64 data:', error);
                return { ...state, [loadingKey]: false, [dataKey]: [] };
            }
        default:
            return state;
    }
}




function handlePostAction(state, action, loadingKey, successKey) {
    if (!checkStatusCode(action.payload)) {
        return actionOnError()
    }
    // add this code to convert to compressed api
    try {
        var compressedBody = JSON.parse(action.payload.body);
        var newData = decodeAndDecompress(compressedBody.compressed_data);
    }
    catch (e) {
        var newData = JSON.parse(action.payload.body);
    }
    var msgCode;
    try {
        msgCode = newData[0].MsgCode
    }
    catch (e) {
        // msgCode = 200
    }
    if (msgCode === 200) {
        return Object.assign({}, state, {
            [successKey]: true,
            [loadingKey]: false
        });
    }
    else {
        try {
            window.alert(newData[0].MSG)
        }
        catch (e) {
            window.alert('Error, please try again.')
        }
        return Object.assign({}, state, {
            [successKey]: false,
            [loadingKey]: false
        });
    }
}

export const VasReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.RESET_REDUX_STATE:
            state = initialState;
            return state


        case types.ON_ERROR:
            var errorstate = actionOnError(state)
            return errorstate;




        /* ################################### EXTERNAL API ACTIONS ################################### */
        case types.CUSTOMS_CITY_API_GET:
            return Object.assign({}, state, {
                isGetCustomsCityAPILoading: true,
                GetCustomsCityAPISuccessful: false
            });
        case types.CUSTOMS_CITY_API_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                // actionOnError()
                return Object.assign({}, state, {
                    isGetCustomsCityAPILoading: false,
                    GetCustomsCityAPISuccessful: false
                });
            }
            else {
                return Object.assign({}, state, {
                    isGetCustomsCityAPILoading: false,
                    GetCustomsCityAPISuccessful: true
                });
            }
        case types.CUSTOMS_CITY_API_ERROR:
            return Object.assign({}, state, {
                isGetCustomsCityAPILoading: false,
                GetCustomsCityAPISuccessful: false
            });










        /* ################################### VAS ACTIONS ################################### */
        case types.CUSTOMS_CITY_MESSAGES_GET:
            return Object.assign({}, state, {
                isCustomsCityMessagesLoading: true
            });
        case types.CUSTOMS_CITY_MESSAGES_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isCustomsCityMessagesLoading: false,
                CustomsCityMessagesData: newData
            });



        case types.DASHBOARD_SUMMARY_GET:
            return Object.assign({}, state, {
                isDashboardSummaryLoading: true
            });
        case types.DASHBOARD_SUMMARY_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isDashboardSummaryLoading: false,
                DashboardSummaryData: newData
            });



        case types.MAWB_GET:
            return Object.assign({}, state, {
                isMawbLoading: true
            });
        case types.MAWB_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            try {
                if (msgCode === 400) {
                    return Object.assign({}, state, {
                        isMawbLoading: false,
                        MawbData: []
                    });

                }
                else {
                    return Object.assign({}, state, {
                        isMawbLoading: false,
                        MawbData: newData
                    });
                }
            }
            catch (e) {
                return Object.assign({}, state, {
                    isMawbLoading: false,
                    MawbData: newData
                });
            }




        case types.POST_MAWB_GET:
            return Object.assign({}, state, {
                MawbSaveSuccessful: false
            });
        case types.POST_MAWB_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                window.alert('Save Successful')
                return Object.assign({}, state, {
                    MawbSaveSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    MawbSaveSuccessful: false
                    // MawbData: newData
                });
            }

        case types.POST_MAWB_EVOLVE_DATA_GET:
            return Object.assign({}, state, {
                MawbEvolveDataSaveSuccessful: false
            });
        case types.POST_MAWB_EVOLVE_DATA_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    MawbEvolveDataSaveSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    MawbEvolveDataSaveSuccessful: false
                    // MawbData: newData
                });
            }

        case types.POST_MAWB_ADD_GET:
            return Object.assign({}, state, {
                MawbAddSuccessful: false
            });
        case types.POST_MAWB_ADD_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Add Successful')
                return Object.assign({}, state, {
                    MawbAddSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    MawbAddSuccessful: false
                    // MawbData: newData
                });
            }


        case types.MAWB_RECOVERY_GET:
            return Object.assign({}, state, {
                isMawbRecoveryLoading: true
            });
        case types.MAWB_RECOVERY_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isMawbRecoveryLoading: false,
                MawbRecoveryData: newData
            });

        case types.POST_MAWB_RECOVERY_GET:
            return Object.assign({}, state, {
                MawbRecoverySaveSuccessful: false
            });
        case types.POST_MAWB_RECOVERY_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    MawbRecoverySaveSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    MawbRecoverySaveSuccessful: false
                    // MawbData: newData
                });
            }

        case types.POST_MAWB_PICKUP_GET:
            return Object.assign({}, state, {
                MawbPickupSaveSuccessful: false
            });
        case types.POST_MAWB_PICKUP_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    MawbPickupSaveSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    MawbPickupSaveSuccessful: false
                    // MawbData: newData
                });
            }

        case types.MAWB_STATUS_GET:
            return Object.assign({}, state, {
                isMawbStatusLoading: true
            });
        case types.MAWB_STATUS_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isMawbStatusLoading: false,
                MawbStatusData: newData
            });

        case types.POST_MAWB_STATUS_GET:
            return Object.assign({}, state, {
                MawbStatusPostSuccessful: false
            });
        case types.POST_MAWB_STATUS_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Add Successful')
                return Object.assign({}, state, {
                    MawbStatusPostSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    MawbStatusPostSuccessful: false
                    // MawbData: newData
                });
            }

        case types.MAWB_CARRIER_GET:
            return Object.assign({}, state, {
                isMawbCarrierLoading: true
            });
        case types.MAWB_CARRIER_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isMawbCarrierLoading: false,
                MawbCarrierData: newData
            });


        case types.HAWB_GET:
            return Object.assign({}, state, {
                isHawbLoading: true
            });
        case types.HAWB_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isHawbLoading: false,
                HawbData: newData
            });


        case types.HAWB_T86_GET:
            return Object.assign({}, state, {
                isHawbT86Loading: true
            });
        case types.HAWB_T86_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isHawbT86Loading: false,
                HawbT86Data: newData
            });




        case types.XDOCK_HAWB_T86LIST_GET:
        case types.XDOCK_HAWB_T86LIST_GET_COMPLETE:
            return handleAction(state, action,
                'isXdockHawbT86ListGetLoading',
                'XdockHawbT86ListData',
                types.XDOCK_HAWB_T86LIST_GET,
                types.XDOCK_HAWB_T86LIST_GET_COMPLETE);










        case types.POST_HAWB_GET:
            return Object.assign({}, state, {
                PostHawbSuccessful: false
            });
        case types.POST_HAWB_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    PostHawbSuccessful: true
                });
            }
            else if (msgCode === 600) {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('House Ref already exists in system.')
                }
                return Object.assign({}, state, {
                    PostHawbSuccessful: false
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    PostHawbSuccessful: false
                });
            }

        case types.HAWB_RECOVERY_GET:
            return Object.assign({}, state, {
                isHawbRecoveryLoading: true
            });
        case types.HAWB_RECOVERY_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isHawbRecoveryLoading: false,
                HawbRecoveryData: newData
            });


        case types.POST_HAWB_RECOVERY_GET:
            return Object.assign({}, state, {
                HawbRecoverySaveSuccessful: false
            });
        case types.POST_HAWB_RECOVERY_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    HawbRecoverySaveSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    HawbRecoverySaveSuccessful: false
                    // MawbData: newData
                });
            }


        case types.XDOCK_POST_HAWB_RECOVERED_SHORT_GET:
            return Object.assign({}, state, {
                HawbRecoveredShortPostSuccessful: false
            });
        case types.XDOCK_POST_HAWB_RECOVERED_SHORT_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    HawbRecoveredShortPostSuccessful: true
                    // MawbData: newData
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    HawbRecoveredShortPostSuccessful: false
                    // MawbData: newData
                });
            }

        case types.HAWB_CONSIGNEE_GET:
            return Object.assign({}, state, {
                isHawbConsigneeLoading: true
            });
        case types.HAWB_CONSIGNEE_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isHawbConsigneeLoading: false,
                HawbConsigneeData: newData
            });

        case types.HAWB_DESTINATION_GET:
            return Object.assign({}, state, {
                isHawbDestinationLoading: true
            });
        case types.HAWB_DESTINATION_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isHawbDestinationLoading: false,
                HawbDestinationData: newData
            });




        case types.LOAD_GET:
            return Object.assign({}, state, {
                isLoadLoading: true
            });
        case types.LOAD_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }

            if (msgCode === 400) {
                return Object.assign({}, state, {
                    isLoadLoading: false,
                    LoadData: []
                });
            }
            else {
                return Object.assign({}, state, {
                    isLoadLoading: false,
                    LoadData: newData
                });
            }


        case types.LOAD_HAWB_GET:
            return Object.assign({}, state, {
                isLoadHawbLoading: true
            });
        case types.LOAD_HAWB_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isLoadHawbLoading: false,
                LoadHawbData: newData
            });

        case types.POST_LOAD_GET:
            return Object.assign({}, state, {
                PostLoadSuccessful: false
            });
        case types.POST_LOAD_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    PostLoadSuccessful: true
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    PostLoadSuccessful: false
                });
            }

        case types.POST_LOAD_REMOVE_GET:
            return Object.assign({}, state, {
                PostLoadRemoveSuccessful: false
            });
        case types.POST_LOAD_REMOVE_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    PostLoadRemoveSuccessful: true
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    PostLoadRemoveSuccessful: false
                });
            }



        case types.POST_LOAD_EDIT_GET:
            return Object.assign({}, state, {
                PostLoadEditSuccessful: false
            });
        case types.POST_LOAD_EDIT_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    PostLoadEditSuccessful: true
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    PostLoadEditSuccessful: false
                });
            }

        case types.LOAD_HAWB_HISTORY_GET:
            return Object.assign({}, state, {
                isLoadHawbHistoryLoading: true
            });
        case types.LOAD_HAWB_HISTORY_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isLoadHawbHistoryLoading: false,
                LoadHawbHistoryData: newData
            });



        case types.OUTBOUND_GET:
            return Object.assign({}, state, {
                isOutboundLoading: true
            });
        case types.OUTBOUND_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isOutboundLoading: false,
                OutboundData: newData
            });


        case types.POST_USER_COLOR_GET:
            return Object.assign({}, state, {
                PostUserColorSuccessful: false
            });
        case types.POST_USER_COLOR_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                return actionOnError()
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    PostUserColorSuccessful: true
                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    PostUserColorSuccessful: false
                });
            }





        case types.XDOCK_MAWB_FILEUPLOAD_GET:
            return Object.assign({}, state, {
                isXdockMawbFileUploadLoading: true
            });
        case types.XDOCK_MAWB_FILEUPLOAD_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isXdockMawbFileUploadLoading: false,
                XdockMawbFileUploadData: newData
            });


        case types.XDOCK_POST_MAWB_FILEUPLOAD_GET:
            return Object.assign({}, state, {
                XdockMawbFileUploadPostSuccessful: false
            });
        case types.XDOCK_POST_MAWB_FILEUPLOAD_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    XdockMawbFileUploadPostSuccessful: true

                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    XdockMawbFileUploadPostSuccessful: false
                });
            }












        case types.XDOCK_LOAD_FILEUPLOAD_GET:
            return Object.assign({}, state, {
                isXdockLoadFileUploadLoading: true
            });
        case types.XDOCK_LOAD_FILEUPLOAD_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isXdockLoadFileUploadLoading: false,
                XdockLoadFileUploadData: newData
            });


        case types.XDOCK_POST_LOAD_FILEUPLOAD_GET:
            return Object.assign({}, state, {
                XdockLoadFileUploadPostSuccessful: false
            });
        case types.XDOCK_POST_LOAD_FILEUPLOAD_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    XdockLoadFileUploadPostSuccessful: true

                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    XdockLoadFileUploadPostSuccessful: false
                });
            }







        case types.XDOCK_TRINITY_DATA_FILE_GET:
            return Object.assign({}, state, {
                isXdockTrinityDataFileLoading: true
            });
        case types.XDOCK_TRINITY_DATA_FILE_GET_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isXdockTrinityDataFileLoading: false,
                XdockTrinityDataFileData: newData
            });


        case types.XDOCK_TRINITY_DATA_GET:
            return Object.assign({}, state, {
                isXdockTrinityDataLoading: true
            });
        case types.XDOCK_TRINITY_DATA_GET_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isXdockTrinityDataLoading: false,
                XdockTrinityData: newData
            });



        case types.XDOCK_LOAD_PALLET_CARTON_GET:
            return Object.assign({}, state, {
                isXdockLoadPalletCartonLoading: true
            });
        case types.XDOCK_LOAD_PALLET_CARTON_GET_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isXdockLoadPalletCartonLoading: false,
                XdockLoadPalletCartonData: newData
            });





        case types.XDOCK_LOAD_PALLET_CARTON_POST:
            return Object.assign({}, state, {
                XDockLoadPalletCartonPostSuccessful: false,
                newPalletIDCarton: null,
            });
        case types.XDOCK_LOAD_PALLET_CARTON_POST_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            var newPalletIDCarton;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }
            try {
                newPalletIDCarton = newData[0].LoadPalletID
            }
            catch (e) {
                newPalletIDCarton = null
            }
            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    XDockLoadPalletCartonPostSuccessful: true,
                    newPalletIDCarton: newPalletIDCarton

                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    XDockLoadPalletCartonPostSuccessful: false,
                    newPalletIDCarton: null
                });
            }



        case types.XDOCK_LOAD_PALLET_POST:
            return Object.assign({}, state, {
                XDockLoadPalletPostSuccessful: false,
                newPalletID: null
            });
        case types.XDOCK_LOAD_PALLET_POST_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            var newPalletID;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }

            try {
                newPalletID = newData[0].newID
            }
            catch (e) {
                newPalletID = null
            }


            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    XDockLoadPalletPostSuccessful: true,
                    newPalletID: newPalletID

                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    XDockLoadPalletPostSuccessful: false,
                    newPalletID: null
                });
            }




        case types.XDOCK_LOAD_PALLET_GET:
            return Object.assign({}, state, {
                isXdockLoadPalletLoading: true
            });
        case types.XDOCK_LOAD_PALLET_GET_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isXdockLoadPalletLoading: false,
                XdockLoadPalletData: newData.data
            });

        case types.XDOCK_CUSTOMS_CITY_MANIFEST_HISTORY_GET:
            return Object.assign({}, state, {
                isXdockCustomsCityManifestHistoryLoading: true
            });
        case types.XDOCK_CUSTOMS_CITY_MANIFEST_HISTORY_GET_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            return Object.assign({}, state, {
                isXdockCustomsCityManifestHistoryLoading: false,
                XdockCustomsCityManifestHistoryData: newData.data
            });












        case types.XDOCK_MAWB_CARRIERREF_POST:
            return Object.assign({}, state, {
                XDockMawbCarrierRefPostSuccessful: false,
                newCarrierID: null
            });
        case types.XDOCK_MAWB_CARRIERREF_POST_COMPLETE:
            if (!checkStatusCode(action.payload)) {
                actionOnError()
                return state;
            }
            var compressedBody = JSON.parse(action.payload.body);
            var newData = decodeAndDecompress(compressedBody.compressed_data);
            var msgCode;
            var newCarrierID;
            try {
                msgCode = newData[0].MsgCode
            }
            catch (e) {
                msgCode = 200
            }

            try {
                newCarrierID = newData[0].CarrierID
            }
            catch (e) {
                newCarrierID = null
            }


            if (msgCode === 200) {
                // window.alert('Save Successful')
                return Object.assign({}, state, {
                    XDockMawbCarrierRefPostSuccessful: true,
                    newCarrierID: newCarrierID

                });
            }
            else {
                try {
                    window.alert(newData[0].MSG)
                }
                catch (e) {
                    window.alert('Error, please try again.')
                }
                return Object.assign({}, state, {
                    XDockMawbCarrierRefPostSuccessful: false,
                    newCarrierID: null
                });
            }







        default:
            return state;
    }
};





export default VasReducer;
